import { Pencil1Icon } from "@radix-ui/react-icons";
import { Row, Table } from "@tanstack/react-table";
import { useState } from "react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog/alert-dialog";

import { Input } from "@/components/ui/input/input";

import { SalaryComponent } from "./schema";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select/select";
import { Textarea } from "@/components/ui/textarea/textarea";

interface UpdateRowModalProps<TData> {
  row: Row<TData>;
  table: Table<TData>;
}

export const UpdateRowModal = <TData,>({
  row,
  table,
}: UpdateRowModalProps<TData>) => {
  const originData = row.original as SalaryComponent;

  const [rowData, setRowData] = useState<{
    type?: string;
    amount?: number;
    name?: string;
    description?: string;
  }>(() => originData);

  const [open, setOpen] = useState(false);

  return (
    <>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogTrigger>
          <span className="cursor-pointer transition-all duration-300">
            <Pencil1Icon className="w-6 h-6 transition-all duration-300 p-1 hover:bg-ring/10 rounded-full" />
          </span>
        </AlertDialogTrigger>
        <AlertDialogContent className="max-w-xl">
          <AlertDialogHeader>
            <AlertDialogTitle className="tracking-normal">
              Edit Component
            </AlertDialogTitle>
          </AlertDialogHeader>

          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <label htmlFor="type">Type</label>
              <Select
                value={rowData.type}
                onValueChange={(value) => {
                  setRowData((prev) => {
                    return {
                      ...prev,
                      type: value,
                    };
                  });
                }}
              >
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="component type" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Earning">Earning</SelectItem>
                  <SelectItem value="Deduction">Deduction</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="name">Name</label>
              <Input
                id="name"
                name="name"
                value={rowData.name}
                onChange={(e) => {
                  setRowData((prev) => {
                    return {
                      ...prev,
                      [e.target.name]: e.target.value,
                    };
                  });
                }}
              />
            </div>
            <div className="flex flex-col gap-2">
              <label htmlFor="amount">Amount</label>
              <Input
                id="amount"
                name="amount"
                value={rowData.amount}
                onChange={(e) => {
                  setRowData((prev) => {
                    return {
                      ...prev,
                      [e.target.name]: e.target.value,
                    };
                  });
                }}
              />
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="description">Description</label>
              <Textarea
                id="description"
                name="description"
                value={rowData.description}
                onChange={(e) => {
                  setRowData((prev) => {
                    return {
                      ...prev,
                      [e.target.name]: e.target.value,
                    };
                  });
                }}
              />
            </div>
          </div>

          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                // @ts-ignore
                table.options.meta?.updateRow(row.index, rowData);

                setOpen(false);
              }}
            >
              Add
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
